<h6 class="onlyPrint">OnDRM <b> v1.1.1</b></h6>
<div class="report__header">
  <div class="dpo">
    <label>DPO</label>
    <div class="img__container">
      <!-- <img src="assets/logos/elxire.png" alt="elxire"> -->
      <img src="assets/logos/pioneer.png" alt="pioneer" />
    </div>

    <!-- <h5>VIZAG BROADCASTING
            COMPANY PVT. LTD, (VBC)</h5>
        <h6>
            #47 -10-20, Flat No. 401, 4th floor,
            Dwaraka Plaza, Dwaraka Nagar,
            Visakhpatanam - 530016</h6>
        <h6>Phone: (0891) 6677-123, 6677-124</h6> -->
    <!-- <h5>ELXIRE</h5>
       <tr>
      <td>Company Name</td>
      <td>{{comapanyDetails.name}}</td>
    </tr>
    <tr>
      <td>Address</td>
      <td>"{{comapanyDetails.address}}"</td>
    </tr>
        <h6>SCF-65, Sector-7 HUDA Market,
            Faridabad - 121006
        </h6>
        <h6>E-mail: info@elxireit.in</h6> -->
    <h5>{{ comapanyDetails.name }}</h5>
    <h6>"{{ comapanyDetails.address }}"</h6>
    <h6>Phone: 9803596305</h6>
  </div>
  <div class="cas">
    <label>CAS Vendor</label>
    <div class="img__container">
      <img src="assets/logos/onnet.png" alt="VBC" />
    </div>

    <h5>Onnet Systems India Pvt. Ltd.</h5>
    <h6>
      Unit 702, 7th floor, Brigade Rubix, 20,HMT Watch Factory Main Road, Peenya
      1st Stage, Bengaluru, Karnataka 560013
    </h6>
    <h6>Phone: +91 802 9724 142 / 52</h6>
  </div>
</div>
